define.alias("shared/components/shared/post-tagging/color-circle", "settings/components/shared/post-tagging/color-circle");